import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { Api } from './index';
import axios, { AxiosResponse } from 'axios';
import { LeadPreferenceType, Tabs } from './types';
import {
	BackgroundCheckBody,
	BackgroundCheckParams,
	BackgroundUpdateParams,
	Bucket,
	BucketResponse,
	Competency,
	CompetencyResponse,
	Industry,
	IndustryResponse,
	PartialNull,
	Questionnaire,
} from './types/user-api-types';
import { publicIpv4 } from 'public-ip';

export default function setAuthorizationBearerToken() {
	Api.defaults.headers.common.Authorization = `Bearer ${Cookies.get('access')}`;
	return null;
}

export const ipApi =
	'https://dr5uhki0g9.execute-api.us-east-1.amazonaws.com/dev/whois/';

export const createCandidate = async (body: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	const result = await Api.post('/api/candidate', body)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getCandidatesList = async (status: Tabs) => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	const result = await Api.get(`api/get-candidate/${status}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getCandidateData = async (id: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	const result = await Api.get(`api/candidate/${id}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getSummaryCount = async () => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	const result = await Api.get(`api/getSummary`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getCandidateSummary = async (id: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	const result = await Api.get(`api/candidate/candidate-summary/${id}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getRefereeDetails = async (item: any) => {
	const result = await Api.get(`/api/jobHistory/${item}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getRefereeDetails2 = async (item: any) => {
	const result = await Api.get(`/api/refree/${item}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const addToArchive = async (body: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	const result = await Api.post('/api/candidateArchive', body)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getCandidateArchieve = async (page: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	const result = await Api.get(`api/candidate/candidateArchive/${page}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getCandidateLifeCycle = async (id: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	const result = await Api.get(`api/lifeCycle/${id}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getPDF = async (JobId: string) => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	const result = await Api.get(`api/get-pdf/` + JobId, { responseType: 'blob' })
		.then((response: any) => {
			return response;
		})
		.catch((e: any) => {
			return e;
		});
	return result;
};

export const addJobHistory = async (body: any) => {
	const result = await Api.post('/api/jobHistory', body)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getJobHistory = async (id: any) => {
	let result = null;
	try {
		result = await Api.get(
			`${process.env.REACT_APP_API_URL}/api/jobHistory/job-history-candidate/${id}`
		)
			.then((response: any) => {
				return response;
			})
			.catch((e: { response: any }) => {
				return e.response;
			});
	} catch (e: any) {
		return e.response;
	}
	if (result.status < 400) return result.data;
	return result;
};

export const getJobHistorybyId = async (id: any) => {
	const result = await Api.get(`api/jobHistory/${id}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const updateCandidateJobHistory = async (id: any, body: any) => {
	await Api.patch(`/api/jobHistory/${id}`, body)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	const result3 = await Api.get(`api/jobHistory/${id}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	await Api.patch(`/api/refree/${result3.data.refree}`, body)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return { status: 200 };
	//return result;
};

export const sendRefereeDeclineMail = async (id: any) => {
	const result = await Api.get(`api/jobHistory/decline/${id}`).then(
		(response: any) => response
	);
	return result;
};
export const removeJobHistory = async (id: any) => {
	const result = await Api.delete(`/api/jobHistory/${id}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const sendEmail = async (id: any) => {
	const result = await Api.post(`/api/jobHistory/job-history-mail/${id}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const addQuestionnaireResponse = async (body: any) => {
	//   Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get('access')}`
	const result = await Api.post(`/api/questionaire-response`, body)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getQuestionnaireResponse = async (id: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	const result = await Api.get(`api/questionaire-response/get-response/${id}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const sendCompleteEmail = async (userType: any, id: any) => {
	const result = await Api.post(`/api/referenceCompleted/${userType}/${id}`)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const updateLifeCycle = async (body: any) => {
	const result = await Api.post(`api/lifeCycle`, body)
		.then((response: any) => {
			return response;
		})
		.catch((e: { response: any }) => {
			return e.response;
		});
	return result;
};

export const getAdminSummary = async () => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	try {
		const { data } = await Api.get(`api/get-admin-summary`);
		return data;
	} catch (e) {
		return e;
	}
};

export const getAdminReport = async (status: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	try {
		const { data } = await Api.get(`api/adminReport?candidateStatus=${status}`);
		return data;
	} catch (e) {
		return e;
	}
};

export const filterByAdminReport = async (status: any, recruiterId: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const { data } = await Api.get(
			`api/adminReport?candidateStatus=${status}&recruiter_id=${recruiterId}`
		);
		return data;
	} catch (e) {
		return e;
	}
};

export const getAllUserAdmin = async () => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const { data } = await Api.get(`auth/all-user-admin`);
		return data;
	} catch (e) {
		return e;
	}
};

export const getQuestionnaires = async (): Promise<Array<Questionnaire>> => {
	Api.defaults.headers.common['Authorization'] = `Bearer  ${Cookies.get(
		'access'
	)}`;
	try {
		const { data } = await Api.get(`api/questionnaire`);
		return data;
	} catch (e: any) {
		return e.response;
	}
};
//written by vijaykumar on 26th Oct 2022 to pull the ISP details from external API
export const getISP = async (ipaddress: any) => {
	//const ispURL = "http://ip-api.com/json/${ipaddress}";
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const {
			data: { results },
		} = await Api.get(`api/request-builder?ip=${ipaddress}`);
		return results;
	} catch (e: any) {
		return e.response;
	}
};
//written by vijaykumar on 14th Oct 2022 to pull the search result for template builder page
export const getQuestionsBySearchQuery = async (query: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const {
			data: { results },
		} = await Api.get(`api/question-builder?search=${query}`);
		return results;
	} catch (e: any) {
		return e.response;
	}
};

//written by vijaykumar on 14th Oct 2022 to pull the questions based on the given bucket type for template builder page

export const getQuestionsByBucketType = async (id: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const { data } = await Api.get(`api/question-builder?bucket=${id}`);
		return data;
	} catch (e: any) {
		return e.response;
	}
};

export const getQuestionsByCompetencyType = async (id: string) => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const { data } = await Api.get(`api/competencyFilter?competency=${id}`);
		return data;
	} catch (e: any) {
		return e.response;
	}
};

export const getIndustries = async (page: number): Promise<Industry[]> => {
	try {
		Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
			'access'
		)}`;
		const {
			data: { results },
		} = (await Api.get(
			`api/industry?page=${page}`
		)) as AxiosResponse<IndustryResponse>;
		return results;
	} catch (e: any) {
		return e.response;
	}
};

export const getCompetencies = async (page: number): Promise<Competency[]> => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const {
			data: { results },
		} = (await Api.get(
			`api/competency?page=${page}`
		)) as AxiosResponse<CompetencyResponse>;
		return results;
	} catch (e: any) {
		return e.response;
	}
};

export const getBuckets = async (page: number): Promise<Bucket[]> => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const {
			data: { results },
		} = (await Api.get(
			`api/bucket?page=${page}`
		)) as AxiosResponse<BucketResponse>;
		return results;
	} catch (e: any) {
		return e.response;
	}
};

export const buildQuestionnaire = async (body: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		return await Api.post(`api/build-questionnaire`, body);
	} catch (e: any) {
		return e.response;
	}
};
export const createQuestionnaire = async (body: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		return await Api.post(`api/questionnaire`, body);
	} catch (e: any) {
		return e.response;
	}
};

export const getQuestionnaireForReferee = async (jobId: any) => {
	try {
		const { data } = await Api.get(`api/get-questionnaire/${jobId}`);
		return data;
	} catch (e: any) {
		return e.response;
	}
};

export const archiveQuestionnaire = async (id: any, result = true) => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		return await Api.patch(`api/questionnaire/${id}`, { is_archived: result });
	} catch (e: any) {
		return e.response;
	}
};

export const getAllQuestions = async () => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const { data } = await Api.get(`api/question-builder`);
		return data;
	} catch (e: any) {
		console.info(e);
		return [];
	}
};

export const addCustomQuestion = async (question: any) => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const { data } = await Api.post(`api/custom-questions`, question);
		return data;
	} catch (e: any) {
		toast.error(e.response);
	}
};

export const getCustomQuestionsForThisUser = async () => {
	Api.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get(
		'access'
	)}`;
	try {
		const { data } = await Api.get(`api/custom-questions`);
		return data;
	} catch (e: any) {
		toast.error(e.response);
	}
};

export const getIP = async () => {
	let ip = localStorage.getItem('Ip');
	ip ||= await publicIpv4({ onlyHttps: true });
	return ip;
};

export const getISPDetails = async (
	ip: string | null | undefined,
	signal: AbortSignal | undefined
) => {
	try {
		const { data } = await axios.get(ipApi + ip, { signal });
		let idx1 = data?.indexOf('netname:');
		let idx2 = data?.indexOf('descr:');
		const isp = data
			?.substring(idx1, idx2)
			?.split(' ')
			?.filter((val: string | any[]) => val?.length !== 0)?.[1]
			?.trim();
		return isp;
	} catch (e) {
		console.error(e);
	}
};

export const unarchiveRequest = async (body: { archive_uuid: string }) => {
	try {
		Api.defaults.headers.common.Authorization = `Bearer ${Cookies.get(
			'access'
		)}`;
		const response = await Api.post('/api/candidateArchive/unarchive/', body);
		if (response.status >= 200 && response.status < 300)
			toast.success('Request has been unarchived successfully!');
		return response;
	} catch (e) {
		if (
			typeof e === 'object' &&
			'message' in e! &&
			typeof e.message === 'string'
		)
			toast.error(e.message);
		return { status: 400 };
	}
};

export const checkRequestArchiveStatus = async (id: string) => {
	try {
		const response = await Api.get(`/api/candidateMore/${id}`);
		return response.status;
	} catch (e) {
		return 404;
	}
};

export const checkJobHistoryArchive = async (id: string) => {
	try {
		const response = await Api.get(`/api/jobHistory/${id}`);
		return response.status;
	} catch (e) {
		return 404;
	}
};

export async function getLeadInfo(
	id: string
): Promise<LeadPreferenceType | void> {
	try {
		const response = await Api.get(`/api/get-lead-info/${id}`);
		return response.data;
	} catch (e) {
		toast.error('Error fetching referee info');
	}
}

export async function doBackgroundCheck(body: BackgroundCheckBody) {
	try {
		const response = await Api.post(`/api/backgoundCheck`, body);
		return response.data;
	} catch (e) {
		return e;
	}
}

export async function getCheckType() {
	try {
		const response = await Api.get(`/api/checkType`);
		return response.data;
	} catch (e) {
		return e;
	}
}

export async function getBackgroundCheck(
	params: Partial<PartialNull<BackgroundCheckParams>>
): Promise<any> {
	const response = await Api.get(`/api/backgoundCheck`, { params });
	return response.data;
}

export async function doUpdateBackgroundCheck({
	uuid,
	body,
}: BackgroundUpdateParams) {
	try {
		const response = await Api.put(`/api/backgoundCheck/${uuid}`, body);
		return response.data;
	} catch (e) {
		return e;
	}
}

export async function getReport(uuid: string) {
	try {
		const response = await Api.get(`/api/backgoundCheck/report/${uuid}/pdf/`, {
			responseType: 'blob',
		});
		return response.data;
	} catch (e) {
		return e;
	}
}

export async function getReportHTML(uuid: string): Promise<{ html: string }> {
	try {
		const response = await Api.get(`/api/backgoundCheck/report/${uuid}/web/`);
		return response.data;
	} catch (e) {
		console.error(e);
		throw new Error('Did not receive background check report!');
	}
}
